import {
    GetSelectedDropdownValues,
    
    InitializeFilterDropdown,
  
} from "../../../shared/scripts/dropdown-functions";
import {  FormatDate } from "../../../shared/scripts/date-functions";
import { DoArraysOverlap } from "../../../shared/scripts/array-functions";
import _ from 'lodash';

import { KpiRow } from "../../../shared/scripts/kpi-row";
import { ChartCard } from "../../../shared/scripts/chart-card";
import { DonutChartData, DonutChart } from "../../../shared/scripts/donut-chart";
import { RankChart } from "../../../shared/scripts/rank-chart";
import {
    isInLast12Months,
    renderDataTableSearchBox,
    setSingleDropdownOptionByText, clearDropdown, getSelectionText,
} from '../../../shared/scripts/filter-ui-helpers';
export interface PublicationsFiltersVm {
    Authors: string[];
    Centers: string[];
    Years: number[];
    Journals: string[];
    Preprints: string[]; // "Yes"/"No"
}
export type PubDtRow = {
    CenterNames: string[];
    AwardNumbers: string[];
    FundingGrants: string[];

    CenterNameJoined: string;
    AwardNumberJoined: string;
    FundingGrantsJoined: string;

    PubMedId: string;
    Title: string;
    Authors: string;
    AuthorsList: string[];
    PubYear: number | null;

    Journal: string;
    JournalNorm: string;

    PublicationDateUtc: string | null;
    PublicationDateDisplay: string;

    Doi: string;
    Pmcid: string;
    Abstract: string;

    MeshTerms: string[];
    MeshTermsJoined: string;
    Keywords: string[];
    KeywordsJoined: string;

    IsPreprint: boolean;
    MatchKey: string;
};

export interface PublicPublicationsPageVm {
    Publications: PubDtRow[];
  
    PublicationsFilters?: PublicationsFiltersVm;
}

//Const
const EmptyDisplay = '-none-';
const MISSING_AWARD_LABEL = 'Missing award (update on PubMed)';
const MISSING_CENTER_LABEL = '-- Unknown --';

export class PublicationsPage {

 
    private pubsFiltersInited = false;
    //register components once, updates applied once
    private state = {
        centers: null as string[] | null,
        authors: null as string[] | null,
        journals: null as string[] | null,
        years: null as string[] | null,
        preprints: null as string[] | null,
        range: 'all' as 'all' | 'last12'
    };
 
    private chartCard?: ChartCard;
    private pubsRowActionsInited = false;

    private publications: PubDtRow[] = [];
    private publicationsFilters?: PublicationsFiltersVm;
   
    //CONSTRUCTOR
    constructor(input: PublicPublicationsPageVm) {
        const {
            Publications,
      
            PublicationsFilters
        } = input;

        this.publications = Publications ?? [];
        this.publicationsFilters = PublicationsFilters;

       
        this.ensurePublicationsModule();
    }

    // HELPERS------
  

    // --- Helpers reused by filters/CSV ---

    private isAllSelected(selectId: string, selected: string[] | null | undefined): boolean {
        if (!selected || !selected.length) return false;

        const options = document.querySelectorAll<HTMLOptionElement>(`${selectId} option`);
        const uniqueValues = new Set(Array.from(options, o => o.value));

        if (uniqueValues.size === 0) return false;

        const selectedSet = new Set(selected);
        for (const v of uniqueValues) {
            if (!selectedSet.has(v)) return false;
        }
        return true;
    }

    private readSel(selectId: string): string[] | null {
        const $el = $(selectId);
        if ($el.length === 0) return null;

        if ($el.find('option').length === 0) return null;

        const raw = GetSelectedDropdownValues(selectId) as string[] | null;
        const sel = raw ?? [];

        // none selected => match nothing
        if (sel.length === 0) return [];

        // all selected => treat as no filter
        if (this.isAllSelected(selectId, sel)) return null;

        return sel;
    }


    private matchesOne(sel: string[] | null, value?: string): boolean {
        if (sel == null) return true;     // no filter
        if (sel.length === 0) return false; // match nothing
        return value ? sel.includes(value) : false;
    }

    private matchesAny(sel: string[] | null, values?: string[]): boolean {
        if (sel == null) return true;
        if (sel.length === 0) return false;
        return DoArraysOverlap(sel, (values ?? []).filter(Boolean));
    }
    // Pill helper-------
    private renderPills($host: JQuery, items: string[]) {
        $host.empty();
        const clean = (items || []).map(x => (x ?? '').trim()).filter(Boolean);
        if (!clean.length) { $host.text(EmptyDisplay); return; }

        clean.forEach(txt => {
            $host.append(`<span class="pill mr-1">${_.escape(txt)}</span>`);
        });
    }

    //=====================
    // PUBLICATIONS TABLE
    //======================
    // --- Publications (table) ---
    private pubsInited = false;
    private dtPubsStandalone?: DataTables.Api;

    private ensurePublicationsModule(): void {
        if (this.pubsInited) {
            try { this.dtPubsStandalone?.columns.adjust().draw(false); } catch { }
            this.updatePubsCount();
            return;
        }

        const rows = this.publications;

        this.rebuildPubsIndex(rows);      

        if (!this.pubsFiltersInited) {
            this.buildPublicationsFilters();

        }

        const dom = `
    <"d-flex justify-content-end mb-2 pubs-buttons"B>
    <"pubs-search"f>
    rtip
`;


        this.dtPubsStandalone = ($('#pubsTable') as any).DataTable({
            dom,
            paging: false,
            info: false,
            searching: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            fixedColumns: 1,

            order: [[4, "desc"], [0, "asc"]],

            deferRender: true,
            data: rows,


            buttons: [{
                text: `<i class="fas fa-file-download"></i>`,
                titleAttr: 'CSV',
                action: (_e: any, api: DataTables.Api) =>
                    this.exportCsvForVisiblePublications(api, 'Revampp-Publications')
            }],
            columns: [
                // Title + preprint badge
                {
                    data: 'Title',
                    className: 'b-fixed-left font-size12 text-left lh-normal table-column-lg ',
                    title: 'Title',
                    defaultContent: '',
                    render: (d: string, type: string, row: PubDtRow) => {
                        const title = (d || '').trim();
                        if (type !== 'display') return title;

                        const key = this.getPubKey(row);

                        return `
      <a href="#" class="pub-title-link lh-normal font-weight-500"
         data-pubkey="${_.escape(key)}"
         title="View publication details">
        ${_.escape(title || 'Untitled')}
      </a>`;
                    }

                },
                // Center and Award - Render warning msg and tooltip when missing award number.
                {
                    data: 'CenterNameJoined',
                    className: 'text-left font-size12 table-column-sm',
                    title: 'Center',
                    defaultContent: '',
                    render: (d: string, type: string, row: PubDtRow) => {
                        const v = (d || '').trim();
                        if (type !== 'display') return v;

                        // Center missing because award is missing
                        if (!v || v === MISSING_AWARD_LABEL) {
                            const msg =
                                'This publication has no award number on PubMed, so it cannot be associated with a center. ' +
                                'Add or update funding information on the PubMed record (PMID).';

                            return `
        <span class="text-warning font-italic js-tip"
              data-tooltip="${_.escape(msg)}">
          ${_.escape(MISSING_CENTER_LABEL)}
          <i class=" fas fa-question-circle ml-1"></i>
        </span>`;
                        }

                        return _.escape(v);
                    }
                },
                // Authors
                {
                    data: 'Authors', className: 'text-left font-size12 table-column-lg lh-normal', title: 'Authors', defaultContent: '',
                    render: (abs?: string, type?: string) => {
                        const v = (abs || '').trim();
                        if (!v) return '';
                        if (type && type !== 'display') return v;
                        const short = v.length > 120 ? v.slice(0, 120) + '…' : v;
                        return `<span title="${_.escape(v)}">${_.escape(short)}</span>`;
                    }
                },
                // Journal
                { data: 'Journal', className: 'text-left font-size12 table-column-md', title: 'Journal', defaultContent: '' },
                // Pub date
                {
                    data: 'PublicationDateUtc',
                    title: 'Pub Date',
                    className: 'text-left font-size12 table-column-sm',
                    defaultContent: '',
                    render: (_utc?: string, type?: string, row?: PubDtRow) => {
                        const utc = (row?.PublicationDateUtc || '').trim();
                        if (!utc) return '';

                        // Keep raw UTC for sort/search/filter behavior
                        if (type && type !== 'display') return utc;

                        const date = new Date(utc);
                        if (isNaN(date.getTime())) return '';

                        return FormatDate(date, "day-mo-year");
                    }
                },
                // Preprint Col 
                {
                    data: 'IsPreprint',
                    title: 'Preprint',
                    className: 'text-left font-size12 nowrap table-column-xs',
                    defaultContent: '',
                    render: (v?: boolean, type?: string) => {
                        if (type && type !== 'display') return v ? 1 : 0; // numeric sort
                        return v ? 'Yes' : 'No';
                    }
                },

            ]

        }) as DataTables.Api;
   

        const $searchInput = renderDataTableSearchBox({
            sourceSelector: '.pubs-search .dataTables_filter',
            targetSelector: '#custom-search-container',
            placeholder: 'Search Publications'
        });

        $searchInput
            .off('input.pubsVisualSync')
            .on('input.pubsVisualSync', () => {
                this.schedulePublicationsVisualSync();
            });
        $('.pubs-buttons .dt-buttons').addClass('mb-0');
        this.wirePublicationsRowActions();

        this.registerChartCardVisualization();
        this.registerDonutVisualization();
        this.registerKpiVisualization();
        this.registerTopJournalRankVisualization();
        this.kpiRow?.wireEvents();
        this.chartCard?.init();
        this.donutChart?.init();
        this.rankChart?.init();

        this.triggerFilter();
    
        $('#pubs-reset').off('click').on('click', () => {
            this.dtPubsStandalone?.search('');

            this.state.range = 'all';

            // These reset to None Selected
            ['#sel-pubs-center',
                '#sel-pubs-author',
                '#sel-pubs-journal',
                '#sel-pubs-year',
                '#sel-pubs-preprint']
                .forEach(sel => {
                    const $dd = $(sel);
                    $dd.find('option').prop('selected', false);
                    try { ($dd as any).selectpicker('refresh'); } catch { }
                });

            this.triggerFilter();
        });
        this.pubsInited = true;

        requestAnimationFrame(() => {
            try { this.dtPubsStandalone?.columns.adjust(); } catch { }
        });

        this.updatePubsCount();
        
    }


    //==============
    //Modal Styling========
    //===================

    private wirePublicationsRowActions(): void {
        if (this.pubsRowActionsInited) return;

        $(document)
            .off('click', 'a.pub-title-link')
            .on('click', 'a.pub-title-link', (e) => {
                e.preventDefault();

                const key = String((e.currentTarget as HTMLElement).getAttribute('data-pubkey') || '').trim();
                const vm = this.pubsIndex.get(key);

                const $modal = $('#pub-detail-modal');
                if (!vm) {
                    $modal.find('.modal-body').prepend('<div class="alert alert-danger">Publication not found.</div>');
                    $modal.modal('show');
                    return;
                }
                $modal.find('.alert').remove();

                this.fillPubModal(vm);
                $modal.modal('show');
            });

        this.pubsRowActionsInited = true;
    }
    private fillPubModal(p: PubDtRow): void {
        const $modal = $('#pub-detail-modal');

        const setText = (sel: string, val?: string | null) => {
            const $el = $modal.find(sel);
            const v = (val ?? '').trim();
            $el.text(v || EmptyDisplay);
        };

        const setPills = (sel: string, items?: string[] | string | null) => {
            const $el = $modal.find(sel);
            const arr =
                Array.isArray(items) ? items :
                    (typeof items === 'string' ? items.split(/;|,/g) : []);
            this.renderPills($el, arr.map(x => String(x ?? '').trim()).filter(Boolean));
        };

        const pillsCount = (sel: string): number => $modal.find(sel).find('span').length;

        // -----------------------------
        // Header
        // -----------------------------
        setText('[data-pub="Title"]', p.Title);

        // "Last Updated:" / date line
        setText('[data-pub="PubDate"]', p.PublicationDateDisplay || p.PublicationDateUtc || '');

        // -----------------------------
        // Block 1: Center, Publication Status, Journal
        // -----------------------------
        const MISSING_CENTER_MSG =
            'No center was detected for this publication. Missing ReVAMPP Award Number in PubMed.';

        const centers = p.CenterNames;
        const $centersHost = $modal.find('[data-pub="Centers"]');

        // Clear whatever was there
        $centersHost.empty().removeClass('d-none');

        if (centers.length) {
            // Normal case: show pills
            this.renderPills($centersHost, centers);
        } else {
            // Empty center: show warning text 
            $centersHost.html(`
            <div class="text-warning font-italic">
              ${_.escape(MISSING_CENTER_MSG)}
            </div>
          `);
        }
        // Always show a status pill: Preprint OR Published
        const status = p.IsPreprint ? 'Preprint' : 'Published'; setPills('[data-pub="PublicationStatus"]',
            [status]); $modal.find('[data-pub="PublicationStatus"]').toggleClass('d-none', pillsCount('[data-pub="PublicationStatus"]') === 0);
        // Journal 
        const journal = p.Journal ;
        setText('[data-pub="Journal"]', journal);
        $modal.find('#pub-journal-block').toggleClass('d-none', !journal);


        // -----------------------------
        // Block 2: Authors
        // -----------------------------
        const authors = p.Authors ;
        setText('[data-pub="Authors"]', authors);
        $modal.find('#pub-authors-block').toggleClass('d-none', !authors);

        // -----------------------------
        // Abstract (hide label/section when empty)
        // -----------------------------
        const absRaw = (p.Abstract ?? '').trim();

        const $absPrev = $modal.find('[data-pub="AbstractPreview"]');
        const $absFull = $modal.find('[data-pub="AbstractFull"]');
        const $absBtn = $modal.find('#pub-abstract-toggle');

        $absBtn.off('click');

        const hasAbstract = !!absRaw;
        $modal.find('#pub-abstract-label, #pub-abstract-section')
            .toggleClass('d-none', !hasAbstract);

        if (!hasAbstract) {
            $absPrev.html(EmptyDisplay);
            $absFull.html('').addClass('d-none');
            $absBtn.addClass('d-none').text('Read full abstract');
        } else {
            const plain = absRaw.replace(/<br\s*\/?>/gi, '\n');
            const limit = 650;
            const needsToggle = plain.length > limit;

            const previewPlain = needsToggle ? plain.slice(0, limit).trim() + '…' : plain;

            const toHtml = (txt: string) =>
                txt
                    .replace(/<br\s*\/?>/gi, '\n')
                    .split('\n')
                    .map(s => _.escape(s))
                    .join('<br>');

            $absPrev.html(toHtml(previewPlain)).toggleClass('d-none', false);
            $absFull.html(toHtml(absRaw)).addClass('d-none');

            if (needsToggle) {
                $absBtn.removeClass('d-none').text('Read full abstract');
                $absBtn.on('click', () => {
                    const expanded = !$absFull.hasClass('d-none');
                    $absFull.toggleClass('d-none', expanded);
                    $absPrev.toggleClass('d-none', !expanded);
                    $absBtn.text(expanded ? 'Read full abstract' : 'Show less');
                });
            } else {
                $absBtn.addClass('d-none').text('Read full abstract');
            }
        }

        // -----------------------------
        // Identifiers
        // -----------------------------
        const pmid = p.PubMedId ;
        const doi = p.Doi;
        const pmcid = p.Pmcid;

        const $pmidWrap = $modal.find('#pub-id-pmid');
        const $pmcidWrap = $modal.find('#pub-id-pmcid');
        const $doiWrap = $modal.find('#pub-id-doi');

        const $pmidA = $modal.find('[data-pub="PmidLink"]');
        const $pmcidA = $modal.find('[data-pub="PmcidLink"]');
        const $doiA = $modal.find('[data-pub="DoiLink"]');

        $pmidWrap.toggleClass('d-none', !pmid);
        $pmidA.text(pmid);
        if (pmid) $pmidA.attr('href', `https://pubmed.ncbi.nlm.nih.gov/${encodeURIComponent(pmid)}/`);
        else $pmidA.removeAttr('href');

        $pmcidWrap.toggleClass('d-none', !pmcid);
        $pmcidA.text(pmcid);
        if (pmcid) $pmcidA.attr('href', `https://pmc.ncbi.nlm.nih.gov/articles/${encodeURIComponent(pmcid)}/`);
        else $pmcidA.removeAttr('href');

        $doiWrap.toggleClass('d-none', !doi);
        $doiA.text(doi);
        if (doi) $doiA.attr('href', `https://doi.org/${encodeURIComponent(doi)}`);
        else $doiA.removeAttr('href');

        const hasIds = !!(pmid || pmcid || doi);
        $modal.find('#pub-ids-label, #pub-ids-section').toggleClass('d-none', !hasIds);

        // Footer PubMed button
        const $pubmedLink = $modal.find('#pub-pubmed-link');
        if (pmid) $pubmedLink.attr('href', `https://pubmed.ncbi.nlm.nih.gov/${encodeURIComponent(pmid)}/`).removeClass('d-none');
        else $pubmedLink.attr('href', '#').addClass('d-none');
    }

    //Generates a stable publication ID (best available key).
    private getPubKey(r: Partial<PubDtRow>): string {
        const mk = String(r.MatchKey ?? '').trim();
        if (mk) return mk;

        const pmid = String(r.PubMedId ?? '').trim();
        if (pmid) return pmid;

        const title = String(r.Title ?? '').trim().toLowerCase();
        const journal = String(r.Journal ?? '').trim().toLowerCase();
        const year = r.PubYear != null ? String(r.PubYear) : '';
        const doi = String((r as any).Doi ?? '').trim().toLowerCase();
        return `${doi}|${journal}|${year}|${title}`.replace(/\s+/g, ' ');
    }


    //update count
    private updatePubsCount(): void {
        const dt = this.dtPubsStandalone;
        const count = dt ? dt.rows({ search: 'applied' }).count() : 0;
        $('#pubs-count').text(`${count} Publication${count === 1 ? '' : 's'} found`);
    }
    //rebuild table
    private pubsIndex = new Map<string, PubDtRow>();
    private rebuildPubsIndex(rows: PubDtRow[]) {
        this.pubsIndex.clear();
        rows.forEach(r => {
            const key = this.getPubKey(r);
            this.pubsIndex.set(key, r);
        });
    }

    //helper for noselection means all
    private readSelNoSelectionMeansAll(selectId: string): string[] | null {
        const $el = $(selectId);
        if ($el.length === 0) return null;
        if ($el.find('option').length === 0) return null;

        const raw = GetSelectedDropdownValues(selectId) as string[] | null;
        const sel = (raw ?? [])
            .map(s => String(s ?? '').trim())
            .filter(Boolean);

        // none selected => treat as no filter
        if (sel.length === 0) return null;

        // all selected => treat as no filter
        if (this.isAllSelected(selectId, sel)) return null;

        return sel;
    }
    //======================
    // CSV
    //======================
    private buildCsv(headers: string[], rows: string[][]) {
        const esc = (s: any) => `"${String(s).replace(/"/g, '""')}"`;
        return '\uFEFF' + [headers.map(esc).join(','), ...rows.map(r => r.map(esc).join(','))].join('\r\n');
    }

    private downloadCsv(csv: string, filename: string) {
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
    }
 
    private exportCsvForVisiblePublications(dt: DataTables.Api, baseName: string) {
        const rows = dt.rows({ search: 'applied', page: 'all' }).data().toArray() as any[];

        const V = (x: unknown) => (x == null ? '' : String(x).trim());
        const L = (arr: any) =>
            (Array.isArray(arr) ? arr : [])
                .map((s: any) => V(s))
                .filter(Boolean)
                .join('; ');

        const H = [
            'Title',
            'Authors',
            'Journal',
            'Award Number',
            'Publication Date',
            'Centers',
            'Abstract',
            'MeSH Terms',
            'PMID',
            'PMCID',
            'DOI',
            'Funding / Grants',

        ];

        const data = rows.map(r => ([
            V(r.Title),
            V(r.Authors),
            V(r.Journal),
            V(r.AwardNumberJoined) || L(r.AwardNumbers),

            V(r.PublicationDateDisplay || r.PublicationDateUtc),
            V(r.CenterNameJoined) || L(r.CenterNames),
            V(r.Abstract),
            V(r.MeshTermsJoined) || L(r.MeshTerms),
            V(r.PubMedId),
            V(r.Pmcid),
            V(r.Doi),
            V(r.FundingGrantsJoined) || L(r.FundingGrants),


        ]));

        const csv = this.buildCsv(H, data);
        const today = new Date().toISOString().slice(0, 10);
        this.downloadCsv(csv, `${baseName}_${today}.csv`);
    }


    //=================
    // Pub filters
    //====================
    private updatePublicationsTable(rows: PubDtRow[]): void {
        if (!this.dtPubsStandalone) return;

        this.dtPubsStandalone.clear();
        this.dtPubsStandalone.rows.add(rows).draw();

        this.updatePubsCount();
        this.renderKpis(rows);
        this.renderChartCard(rows);
        this.renderDonut(rows);
        this.renderRankChart(rows);
    }
    private triggerFilter(): void {
     
        this.syncStateFromUi();

        const s = this.state;

        let rows = [...this.publications];

        rows = rows.filter(row => {
            const okCenter = this.matchesAny(s.centers, row.CenterNames);
            const okAuthor = this.matchesAny(s.authors, row.AuthorsList);

            const okJournal =
                s.journals == null
                    ? true
                    : s.journals.some(j => j.trim().toLowerCase() === row.JournalNorm);

            const okYear = this.matchesOne(
                s.years,
                row.PubYear != null ? String(row.PubYear) : ''
            );

            const okPreprint = this.matchesOne(
                s.preprints,
                row.IsPreprint ? 'Yes' : 'No'
            );

            const okRange =
                s.range === 'all'
                    ? true
                    : isInLast12Months(row.PublicationDateUtc);

            return okCenter && okAuthor && okJournal && okYear && okPreprint && okRange;
        });

        this.updatePublicationsTable(rows);
    }

    private buildPublicationsFilters(): void {
        $('#pubs-filter-container').html(`
    <div class="row no-gutters align-items-end">
      <div class="col px-1">
        <label class="mb-1 font-size12">Center</label>
        <select id="sel-pubs-center" class="selectpicker" multiple
                data-actions-box="true" data-live-search="true"
                data-width="100%" title="None Selected"></select>
      </div>

      <div class="col px-1">
        <label class="mb-1 font-size12">Author</label>
        <select id="sel-pubs-author" class="selectpicker" multiple
                data-actions-box="true" data-live-search="true"
                data-width="100%" title="None Selected"></select>
      </div>

      <div class="col px-1">
        <label class="mb-1 font-size12">Journal</label>
        <select id="sel-pubs-journal" class="selectpicker" multiple
                data-actions-box="true" data-live-search="true"
                data-width="100%" title="None Selected"></select>
      </div>

      <div class="col px-1">
        <label class="mb-1 font-size12">Year</label>
        <select id="sel-pubs-year" class="selectpicker" multiple
                data-actions-box="true" data-live-search="true"
                data-width="100%" title="None Selected"></select>
      </div>

      <div class="col px-1">
        <label class="mb-1 font-size12">Preprint</label>
        <select id="sel-pubs-preprint" class="selectpicker" multiple
                data-actions-box="true"
                data-width="100%" title="None Selected"></select>
      </div>
    </div>
  `);
        const f = this.publicationsFilters;
        //pass dummy object to bypass default filter trigger.
        const noopFilter = {
            triggerFilter: () => { }
        };
        //populate filters
        InitializeFilterDropdown('#sel-pubs-center', (f?.Centers ?? []).slice(), noopFilter, undefined, false);
        InitializeFilterDropdown('#sel-pubs-author', (f?.Authors ?? []).slice(), noopFilter, undefined, false);
        InitializeFilterDropdown('#sel-pubs-journal', (f?.Journals ?? []).slice(), noopFilter, undefined, false);
        InitializeFilterDropdown('#sel-pubs-year', (f?.Years ?? []).map(String) ?? [], noopFilter, undefined, false);
        InitializeFilterDropdown('#sel-pubs-preprint', (f?.Preprints ?? ['Yes', 'No']).slice(), noopFilter, undefined, false);

        this.pubsFiltersInited = true;
        /*UI change > triggerFilter(): 
        read filters > filter rows > update table > update visuals*/
        $('#pubs-filter-container')
            .find('select')
            .off('changed.bs.select')
            .on('changed.bs.select', () => this.triggerFilter());
        
        
    }

    //KPI cards
    private kpiRow?: KpiRow;

    private getKpiCards(rows: PubDtRow[]) {
        //total + last12 total, preprints total, 
      
        const total = rows.length;
        const last12 = rows.filter(r => isInLast12Months(r.PublicationDateUtc)).length;
        const preprints = rows.filter(r => r.IsPreprint).length;

        const preprintsSelected = this.state.preprints;
        const preprintActive =
            !!preprintsSelected &&
            preprintsSelected.length === 1 &&
            preprintsSelected[0] === 'Yes';

        // Count unique authors from the currently visible rows.
        const authors = new Set<string>();
        rows.forEach(r => {
            r.AuthorsList.forEach(a=> authors.add(a))
        });


        // Count unique journals from the currently visible rows.
       
        const journals = new Set<string>();

        rows
            .filter(r => !r.IsPreprint)
            .forEach(r => {
                const journal = (r.Journal ?? '').trim();
                if (journal) journals.add(journal);
            });

        return [
            {
                id: 'total',
                title: 'Total Publications',
                value: total
            },
            {
                id: 'last12',
                title: 'Publications in Last 12 Months',
                value: last12,
                isClickable: true,
                active: this.state.range === 'last12'
            },
            {
                id: 'preprint',
                title: 'Preprints',
                value: preprints,
                isClickable: true,
                active: preprintActive
            },
            {
                id: 'authors',
                title: 'Contributing Authors',
                value: authors.size
            },
            {
                id: 'journals',
                title: 'Total Journals',
                value: journals.size
            }
        ];
    }

    private registerKpiVisualization(): void {
        this.kpiRow = new KpiRow('#kpi-row-id', (id) => {
            if (id === 'last12') {
                this.state.range = this.state.range === 'last12' ? 'all' : 'last12';
                this.triggerFilter();
                return;
            }
            const isActive =
                this.state.preprints?.length === 1 &&
                this.state.preprints[0] === 'Yes';

            if (isActive) {
                const $preprint = $('#sel-pubs-preprint');

                // None selected = no filter
                $preprint.find('option').prop('selected', false);

                try { ($preprint as any).selectpicker('refresh'); } catch { }
            } else {
                setSingleDropdownOptionByText('#sel-pubs-preprint', 'Yes');
            }
            this.triggerFilter();
        });
    }

    //Table chart
    private getChartData(
        rows: PubDtRow[],
        range: 'all' | 'last12'
    ) {
        const chartRows =
            range === 'all'
                ? rows
                : rows.filter(r => isInLast12Months(r.PublicationDateUtc));

        const centerSet = new Set<string>();

        chartRows.forEach(p => {
            p.CenterNames.forEach(c => centerSet.add(c));
        });

        const categories = Array.from(centerSet).sort((a, b) => a.localeCompare(b));

        const preprint = new Map<string, number>();
        const published = new Map<string, number>();

        const inc = (map: Map<string, number>, key: string) => {
            map.set(key, (map.get(key) ?? 0) + 1);
        };

        chartRows.forEach(p => {
            p.CenterNames.forEach(c => {
                if (p.IsPreprint) inc(preprint, c);
                else inc(published, c);
            });
        });

        return {
            categories,
            series: [
                {
                    key: 'preprint',
                    label: 'Preprint',
                    values: categories.map(c => preprint.get(c) ?? 0),
                    color: '#10426c'
                },
         
                {
                    key: 'published',
                    label: 'Published',
                    values: categories.map(c => published.get(c) ?? 0),
                    color: '#05af55'
                }
             
            ]
        };
    }

    private registerChartCardVisualization(): void {
        this.chartCard = new ChartCard({
            rootSelector: '#chart-card', // make sure HTML id matches
            chartSelector: '#pub-status-by-center-chart',
            initialRange: this.state.range,

            onClearSelection: () => {
                const $center = $('#sel-pubs-center');
                $center.find('option').prop('selected', false);
                try { ($center as any).selectpicker('refresh'); } catch { }

                this.triggerFilter();
            },

            onRangeChange: (range) => {
                this.state.range = range;
                this.triggerFilter();
            },

            onFilterSelect: (request) => {
                if (request.category) {
                    setSingleDropdownOptionByText('#sel-pubs-center', request.category);
                }

                if (request.range) {
                    this.state.range = request.range;
                }

                this.triggerFilter();
            }
        });
    }
  
    //Donut Chart
    private donutChart?: DonutChart;

    private getDonutData(rows: PubDtRow[]): DonutChartData {
        const preprintCount = rows.filter(r => r.IsPreprint).length;
        const publishedCount = rows.filter(r => !r.IsPreprint).length;

        return {
            title: 'Publication Status',
            total: rows.length,
            slices: [
                {
                    key: 'preprint',
                    label: 'Preprint',
                    value: preprintCount,
                    color: '#10426c'
                },
                {
                    key: 'published',
                    label: 'Published',
                    value: publishedCount,
                    color: '#05af55'
                }
            ]
        };
    }
 
    private registerDonutVisualization(): void {
        this.donutChart = new DonutChart({
            rootSelector: '#donut-chart-id',

            onSliceClick: (slice) => {
                if (slice.key === 'preprint') {
                    setSingleDropdownOptionByText('#sel-pubs-preprint', 'Yes');
                }

                if (slice.key === 'published') {
                    setSingleDropdownOptionByText('#sel-pubs-preprint', 'No');
                }

                this.triggerFilter();
            },

            onClearSelection: () => {
                const $preprint = $('#sel-pubs-preprint');

                // Clear = no preprint filter = Yes + No selected
                $preprint.find('option').prop('selected', false);

                try { ($preprint as any).selectpicker('refresh'); } catch { }

                this.triggerFilter();
            }
        });
    }
    //build data and register top ranking chart  
    private rankChart?: RankChart;

    private getTopJournalRankData(rows: PubDtRow[]) {
        const counts = new Map<string, number>();

        rows.forEach((row) => {
            if (row.IsPreprint) return;

            const journalName = row.Journal;
            if (!journalName) return;

            counts.set(journalName, (counts.get(journalName) ?? 0) + 1);
        });

        const topFive = Array.from(counts.entries())
            .sort((a, b) => {
                // higher publication count first
                if (b[1] !== a[1]) return b[1] - a[1];
                // stable alphabetical tie-break
                return a[0].localeCompare(b[0]);
            })
            .slice(0, 5);

        const bgColor = '#05af55';
        const textColor = '#fff';


        return {
            title: 'Top 5 Journals',
            items: topFive.map(([journalName, publicationCount], index) => {
                const rank = (index + 1) as 1 | 2 | 3 | 4 | 5;

                return {
                    rank,
                    journalName,
                    publicationCount,
                    bgColor,
                    textColor,
                   
                };
            })
        };
    }

    private registerTopJournalRankVisualization(): void {
        this.rankChart = new RankChart({
            rootSelector: '#rank-chart-id',
            onBarClick: (journalName) => {
                setSingleDropdownOptionByText('#sel-pubs-journal', journalName);
                this.triggerFilter();
            },
            onClearSelection: () => {
                $('#sel-pubs-journal').find('option').prop('selected', false);
                try { ($('#sel-pubs-journal') as any).selectpicker('refresh'); } catch { }

                this.triggerFilter();
            }
        });
    }

    //Render all visuals
    private renderKpis(rows: PubDtRow[]): void {
        this.kpiRow?.render(this.getKpiCards(rows));
    }

    private renderDonut(rows: PubDtRow[]): void {
        this.donutChart?.setData(this.getDonutData(rows));
        this.donutChart?.setActiveSelection(this.getPreprintSelectionText());
       
    }

    private renderRankChart(rows: PubDtRow[]): void {
        this.rankChart?.setData(this.getTopJournalRankData(rows));
        this.rankChart?.setActiveSelection(this.getJournalSelectionText());
    }
    private renderChartCard(rows: PubDtRow[]): void {
        if (!this.chartCard) return;

        const chartData = this.getChartData(rows, this.state.range);

        this.chartCard.setRange(this.state.range);
        this.chartCard.setChartData(chartData);

        this.chartCard.setActiveSelection(this.getCenterSelectionText());
    }

    private syncStateFromUi(): void {
        this.state.centers = this.readSelNoSelectionMeansAll('#sel-pubs-center');
        this.state.authors = this.readSelNoSelectionMeansAll('#sel-pubs-author');
        this.state.journals = this.readSelNoSelectionMeansAll('#sel-pubs-journal');
        this.state.years = this.readSelNoSelectionMeansAll('#sel-pubs-year');
        this.state.preprints = this.readSelNoSelectionMeansAll('#sel-pubs-preprint');
        this.state.range = this.state.range;
    }


    private syncPublicationsVisualsToVisibleRows(): void {
        if (!this.dtPubsStandalone) return;

        const visibleRows = this.dtPubsStandalone
            .rows({ search: 'applied' })
            .data()
            .toArray() as PubDtRow[];

        this.updatePubsCount();
        this.renderKpis(visibleRows);
        this.renderChartCard(visibleRows);
        this.renderDonut(visibleRows);
        this.renderRankChart(visibleRows);
    }

    private getJournalSelectionText(): string | null {
        return getSelectionText(this.state.journals, 'Journal', {
            treatEmptyAsAll: true
        });
    }
    private getCenterSelectionText(): string | null {
        return getSelectionText(this.state.centers, 'Center');
    }

    private getPreprintSelectionText(): string | null {
        return getSelectionText(this.state.preprints, 'Preprint', {
            requireSingle: true
        });
    }

    //debounce search bar filtering
    private pubsSearchSyncTimer?: number;

    private schedulePublicationsVisualSync(): void {
        window.clearTimeout(this.pubsSearchSyncTimer);

        this.pubsSearchSyncTimer = window.setTimeout(() => {
            this.syncPublicationsVisualsToVisibleRows();
        }, 100);
    }
}